import { EntityType } from '@frontend/common';
import { defaultCellClassName } from '@frontend/components/list';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { CommonMessage } from '@frontend/lang';
import { OrderClient } from '@frontend/order/api';
import { Order } from '@frontend/order/types';
import { useAccountRepository } from '@frontend/repository';
import { useNavigate } from 'react-router-dom';

import { OrderStatusBadge } from '../modal/order-status-badge/order-status-badge';
import { useAppDispatch } from '../redux/store';

const ID = 'order-overview';
export const OrderOverview = () => {
    const { currentAccount } = useAccountRepository();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    return (
        <ReactiveObjectList<Order>
            id={ID}
            useStaticListId
            type={EntityType.ORDER}
            dispatch={dispatch}
            fetch={(arg) => OrderClient.fetchOrders(arg)}
            eventListener={EntityType.ORDER}
            onSelectElement={(o) => navigate(`/accounts/${o.account_id}/orders/${o.id}/detail`)}
            create={{
                label: CommonMessage.OBJECTS.ORDER.DEFAULT,
                onCreate: () => navigate('./create'),
                requiredPermissions: [{ item: EntityType.ORDER, source: EntityType.ACCOUNT, right: 'create', uid: currentAccount ?? '?' }]
            }}
            columns={{
                columns: ['number', 'state', 'user_id', 'product_id', 'quantity', 'workflow_id', 'creation_timestamp'],
                headerOverwrite: new Map([
                    ['state', CommonMessage.OBJECTS.COMMON_FIELDS.STATUS],
                    ['workflow_id', CommonMessage.OBJECTS.WORKFLOW.DEFAULT]
                ]),
                customCells: new Map([
                    [
                        'state',
                        (obj) => (
                            <td
                                key={obj.row.original.id}
                                className={defaultCellClassName}>
                                <OrderStatusBadge status={obj.row.original.state} />
                            </td>
                        )
                    ]
                ])
            }}
            filter={{ default: true }}
            showCount
        />
    );
};
